export interface RequestAirlinePopularInterface {
  limit: number;
  page: number;
  departureCountrySlug: string;
  departureCitySlug: string;
  departureAirportCode: string;
  arrivalCountrySlug: string;
  arrivalCitySlug: string;
  arrivalAirportCode: string;
}

export interface AirlinesPopularInterface {
  status: boolean;
  code: string;
  message: string;
  count: number;
  data: BaseAirlineInfo[];
}
interface BaseAirlineInfo {
  airlineCode: string;
  slug: string;
  name: string;
  imageCircle: string;
  imageSquare: string;
}

export class ResponseAirlinesPopularInterface {
  status: boolean;

  code: string;

  message: string;

  count: number;

  data: BaseAirlineInfo[];

  constructor(data: any) {
    this.status = data.status || false;

    this.code = data.code || "";

    this.message = data.message || "";

    this.count = data.count || null;

    this.data = data.data || null;
  }
}
